import { Component, OnInit, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ScriptLoaderService } from './components/button-script-loader/ButtonScriptLoaderService';
import { MainMenuComponent } from './components/main-menu/main-menu.component';

@Component({
    selector: 'site-root',
    standalone: true,
    imports: [MainMenuComponent, RouterOutlet],
    templateUrl: './site.component.html',
    styleUrl: './site.component.css'
})
export class Site implements OnInit
{
    protected readonly title = signal('UrloSite.client');

    constructor(private scriptLoader: ScriptLoaderService)
    {

    }

    ngOnInit()
    {
        this.scriptLoader.loadButtonScript();
    }
}
